import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Etiketler from '../pages/Etiketler';
import EtiketEkle from '../pages/Etiketler/create';
import Formlar from '../pages/Formlar';
import Reklamlar from '../pages/Reklamlar';
import Profil from '../pages/Profil';
import SifreDegistir from '../pages/SifreDegistir';
import FormDetay from '../pages/FormDetay';
import Logout from '../pages/Logout';
import ProtectedRoute from '../components/ProtectedRoute';
import Reports from '../pages/Reports';
import CustomerCreate from '../pages/Customer/create';

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/labels" element={<ProtectedRoute><Etiketler /></ProtectedRoute>} />
        <Route path="/create-label" element={<ProtectedRoute><EtiketEkle /></ProtectedRoute>} />
        <Route path="/forms" element={<ProtectedRoute><Formlar /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/create-customer" element={<ProtectedRoute><CustomerCreate /></ProtectedRoute>} />
        <Route path="/lead-detail" element={<ProtectedRoute><FormDetay /></ProtectedRoute>} />
        <Route path="/ads" element={<ProtectedRoute><Reklamlar /></ProtectedRoute>} />
        <Route path="/my-account" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><SifreDegistir /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
);

export default AppRoutes;
